// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".marquee[data-v-469f2107]{\n  overflow:hidden;\n  font-size:0;\n  opacity:0;\n  -webkit-transition:opacity .2s;\n  transition:opacity .2s;\n  white-space:nowrap\n}\n.text-wrapper[data-v-469f2107]{\n  will-change:transform\n}\n.visible[data-v-469f2107]{\n  opacity:1\n}\nspan[data-v-469f2107]{\n  display:inline-block\n}", ""]);
// Exports
module.exports = exports;
